import dayjs from 'dayjs';

import { Campaign, Stats } from './types';
import { getCampaignsReportUrl } from './urls';

import { stringToDate } from '@/utils/date';
import { HsmBackendHttpClient, HsmBackendResponse } from '@/utils/http-client';
/**
 * Return the campaigns of a cliengo website
 * @param websiteId
 * @returns an array of Campaign
 */
export async function getCampaignsAndStats(
  websiteId: string,
  dateRange?: string[]
): Promise<{
  campaigns: Campaign[];
  stats: Stats;
}> {
  const client = HsmBackendHttpClient.instance;

  let dateFrom = dayjs().subtract(1, 'month').toDate();
  let dateTo = new Date();

  if (dateRange && dateRange.length === 2) {
    dateFrom = stringToDate(dateRange[0]);
    dateTo = stringToDate(dateRange[1]);
  }

  const { result } = await client.get<
    HsmBackendResponse<{ campaigns: Campaign[]; stats: Stats }>
  >(getCampaignsReportUrl(websiteId, dateFrom, dateTo));

  return result;
}
